import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

// Same categories as in the admin panel
const WORKSHOP_CATEGORIES = [
  'Academic Writing',
  'College Applications',
  'Essay Writing',
  'Interview Prep',
  'Leadership',
  'STEM',
  'Business & Entrepreneurship',
  'Languages',
  'Test Preparation',
  'Portfolio Building',
  'Career Development',
  'Public Speaking',
  'Research & Innovation',
  'Time Management',
  'Other'
];

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  isOpen, 
  onClose 
}) => {
  const categories = [
    { value: 'all', label: 'All Categories' },
    ...WORKSHOP_CATEGORIES.map(cat => ({ value: cat.toLowerCase(), label: cat }))
  ];

  const difficulties = [
    { value: 'all', label: 'All Levels' },
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'popular', label: 'Most Popular' },
    { value: 'upcoming', label: 'Upcoming Sessions' },
    { value: 'rating', label: 'Highest Rated' }
  ];

  const handleCategoryClick = (category) => {
    onFilterChange('category', category);
  };

  return (
    <div className={`
      fixed lg:relative inset-0 lg:inset-auto z-40 lg:z-auto
      ${isOpen ? 'block' : 'hidden lg:block'}
    `}>
      <div 
        className="fixed inset-0 bg-black/50 lg:hidden"
        onClick={onClose}
      ></div>
      <div className="fixed lg:relative right-0 top-0 bottom-0 w-80 lg:w-full bg-card lg:bg-transparent border-l lg:border-0 border-border overflow-y-auto lg:overflow-visible">
        <div className="p-6 lg:p-0">
          <div className="flex items-center justify-between mb-6 lg:hidden">
            <h3 className="text-lg font-semibold text-foreground">Filters</h3>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-md transition-hover"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-foreground mb-3">
                Categories
              </label>
              <div className="flex flex-wrap gap-2">
                {categories?.map((cat) => (
                  <button
                    key={cat?.value}
                    onClick={() => handleCategoryClick(cat?.value)}
                    className={`
                      px-4 py-2 rounded-full text-sm font-medium transition-smooth
                      ${filters?.category === cat?.value
                        ? 'bg-primary text-primary-foreground'
                        : 'bg-muted text-foreground hover:bg-muted/80'
                      }
                    `}
                  >
                    {cat?.label}
                  </button>
                ))}
              </div>
            </div>

            <Select
              label="Difficulty Level"
              options={difficulties}
              value={filters?.difficulty}
              onChange={(value) => onFilterChange('difficulty', value)}
            />

            <Select
              label="Sort By"
              options={sortOptions}
              value={filters?.sort}
              onChange={(value) => onFilterChange('sort', value)}
            />

            <div>
              <Input
                type="date"
                label="Start Date"
                value={filters?.startDate}
                onChange={(e) => onFilterChange('startDate', e?.target?.value)}
              />
            </div>

            <div>
              <Input
                type="date"
                label="End Date"
                value={filters?.endDate}
                onChange={(e) => onFilterChange('endDate', e?.target?.value)}
              />
            </div>

            <div className="pt-4 border-t border-border">
              <Button
                variant="outline"
                fullWidth
                iconName="RotateCcw"
                iconPosition="left"
                onClick={onClearFilters}
              >
                Clear All Filters
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;